import { render, staticRenderFns } from "./spentProducts.vue?vue&type=template&id=6152172a&"
import script from "./spentProducts.vue?vue&type=script&lang=js&"
export * from "./spentProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports